export default "__VITE_ASSET__BR2bKj4Q__"